import * as Toolkit from '../../toolkit/index';

export default function domRender(params: FreeObjMap): void {
    let $container: JQuery = $(`<div class="error_box"></div>`).addClass(params.cube.id);

    params.cube.jView.find(`.error_box.${params.cube.id}`).remove();
    $container.css({
        fontSize: params.warningTxtFontSize
    }).attr('title', params.warningList.join(`<br>`));
    params.cube.jView.append($container);
    Toolkit.html($container, params.warningStr);
}
